import { formatLongDate } from '../dateOnly';

export const TONES = ['good', 'warn', 'bad', 'neutral'];

export function formatMoney(value) {
  if (value === null || value === undefined || value === '') return '—';
  const n = Number(value);
  if (!Number.isFinite(n)) return '—';
  return n.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
}

// enrollment: { status, effectiveDate, terminationDate } with YYYY-MM-DD strings or null
export function enrollmentBadge(e) {
  if (!e) return { label: 'Not enrolled', tone: 'neutral' };
  if (e.status === 'terminated') {
    return { label: e.terminationDate ? `Terminated ${formatLongDate(e.terminationDate)}` : 'Terminated', tone: 'bad' };
  }
  if (e.status === 'active') {
    if (!e.effectiveDate) return { label: 'Active — effective date missing', tone: 'warn' };
    return { label: `Active since ${formatLongDate(e.effectiveDate)}`, tone: 'good' };
  }
  return { label: e.effectiveDate ? `Pending — effective ${formatLongDate(e.effectiveDate)}` : 'Pending — effective date missing', tone: 'warn' };
}

// Accepts a Stedi lookup result ({ supports: {...}, eraEnrollmentRequired }) or a payers table row.
export function payerSupportSummary(p) {
  const s = p.supports || {
    eligibility: p.supports_eligibility, claims: p.supports_claims, claimStatus: p.supports_claim_status, era: p.supports_era,
  };
  const out = [];
  if (s.eligibility) out.push('Eligibility');
  if (s.claims) out.push('Claims');
  if (s.claimStatus) out.push('Claim status');
  if (s.era) out.push(p.eraEnrollmentRequired ? 'ERA (enrollment required)' : 'ERA');
  return out.length ? out : ['No supported transactions'];
}
